module.exports = __webpack_public_path__ + "img/spirit_brown_ba_detail_rsh0.35f8ac7f.jpg";